import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

function EndClassMessage() {
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
  };

  const handleShow = () => {
    setShow(true);
  };

  return (
    <>
      <button
        type="button"
        className="btn btn-success btn-sm"
        style={{ fontSize: "12px" }}
        onClick={handleShow}
      >
        End Class
      </button>

      <Modal show={show} onHide={handleClose} size="md">
        <Modal.Header closeButton>
          <p className="headColor">Important Notice</p>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-12">Pending for Change Class request.</div>
          </div>
        </Modal.Body>
        <Modal.Footer className="mt-3">
          <Button
            className="btn btn-sm btn-border bg-light text-dark"
            onClick={handleClose}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default EndClassMessage;
